import Cover from "../../components/Cover/Cover";
import "./RecipePage.css";
import servicePageDecoration from "../../assets/icons/servicePageDecoration.png";
import { useLocation } from "react-router-dom";

const texts = {
  ua: {
    ingredients: "Інгредієнти",
    steps: "Етапи приготування",
    text: "Готуйте та відмічайте нас в соціальних мережах!",
  },
  ru: {
    ingredients: "Ингредиенты",
    steps: "Этапы приготовления",
    text: "Готовьте и отмечайте нас в социальных сетях!",
  },
};

const RecipePage = ({ recipe }) => {
  const {
    metaTitle,
    metaDescription,
    coverImage,
    coverImageMobile,
    coverTitle,
    aboutText,
    aboutImage,
    ingredients,
    steps,
  } = recipe;

  const isMobile = window.innerWidth <= 1199;
  const coverImageToUse = isMobile ? coverImageMobile : coverImage;
  const location = useLocation();
  const currentLang = location.pathname.startsWith("/ru") ? "ru" : "ua";
  const langPrefix = currentLang === "ru" ? "/ru" : "";
  const t = texts[currentLang];

  return (
    <div className="page">
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <Cover text={coverTitle} src={coverImageToUse} />
      <section className="recipe__page-recipe-text-section">
        <img
          src={servicePageDecoration}
          alt="фото банки з молоком"
          className="product__page-category-info-section-decoration"
        />
        <img
          src={servicePageDecoration}
          alt="фото банки з молоком"
          className="product__page-category-info-section-decoration two"
        />
        <img
          src={servicePageDecoration}
          alt="фото банки з молоком"
          className="product__page-category-info-section-decoration three"
        />
        <img
          src={servicePageDecoration}
          alt="фото банки з молоком"
          className="product__page-category-info-section-decoration four"
        />
        <p className="recipe__page-recipe-text mont-r">{aboutText}</p>
      </section>
      <section className="recipe__page-ingridients-section">
        <h2 className="recipe__page-ingridients-section-title mont-m">
          {t.ingredients}
        </h2>
        <div className="recipe__page-ingridients-wrapper">
          <img
            src={aboutImage}
            alt={"Фото інгридієнтів"}
            className="recipe__page-ingridients-image"
          />
          <div className="recipe__page-ingridients-list">
            {ingredients.map((ingr, idx) => (
              <div key={idx} className="recipe__page-ingridient-item">
                <p className="recipe__page-ingridient-item-title int-r-21">
                  {ingr.title}
                </p>
                <p className="recipe__page-ingridient-item-amount int-r-21">
                  {ingr.amount}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="recipe__page-steps-section">
        <h2 className="recipe__page-steps-section-title mont-m">{t.steps}</h2>
        <div className="recipe__page-steps-wrapper">
          {steps.map((step, idx) => (
            <div key={idx} className="recipe__page-step-item">
              <div className="recipe__page-step-number consol-r">{idx + 1}</div>
              <p className="recipe__page-step-text mont-r">{step}</p>
            </div>
          ))}
        </div>
        <p className="recipe__page-steps-end-text mont-m">{t.text}</p>
      </section>
    </div>
  );
};

export default RecipePage;
